import { styled } from "@pigment-css/react";
import { pressInteraction } from "@acto/taskpane/field-sales-2/styles/pressInteraction";

/**
 * Outlined-pill action button. Hug-width by default: extend with `styled(OutlinedPillButton)`
 * to add width behaviour (e.g. `flex: "1 1 auto"` to grow, or horizontal padding to hug its
 * label).
 */
export const OutlinedPillButton = styled("button")(({ theme }) => ({
  height: theme.fieldSalesTwo.spacing[50],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: `${theme.strokeWidth.thin} solid ${theme.fieldSalesTwo.colors.neutral[200]}`,
  borderRadius: theme.fieldSalesTwo.radius.circular,
  background: "transparent",
  appearance: "none",
  WebkitAppearance: "none",
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[15],
  fontWeight: theme.fieldSalesTwo.font.weight[440],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  color: theme.fieldSalesTwo.colors.neutral[800],
  cursor: "pointer",
  transition: "background 120ms ease, transform 120ms ease",
  "&:hover": {
    background: theme.fieldSalesTwo.colors.surface.glassMedium,
  },
  ...pressInteraction(theme),
  // The outlined family draws the focus ring inset, on top of the border, overriding
  // pressInteraction's offset ring.
  "&:focus-visible": {
    outline: `${theme.strokeWidth.regular} solid ${theme.fieldSalesTwo.colors.neutral[700]}`,
    outlineOffset: `-${theme.strokeWidth.regular}`,
  },
  "&:disabled": {
    opacity: 0.5,
    pointerEvents: "none",
  },
}));
